import * as React from "react";
const SvgFiRrCrutches = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-crutches_svg__a)">
      <path
        fill="#062147"
        d="M23.707 23.707a.997.997 0 0 1-1.414 0l-5-5a.999.999 0 1 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414M21.693 9.378l-5.608 5.608A10.22 10.22 0 0 1 8.81 18H7.414l-5.707 5.707a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L6 16.586v-1.395q.001-.988.182-1.938L2.307 9.378c-.491.316-.8.484-.834.502a1.002 1.002 0 0 1-1.354-.405 1 1 0 0 1 .405-1.354c.02-.01 2.076-1.136 4.19-3.25C6.842 2.744 8.118.527 8.13.505a1 1 0 0 1 1.738.99 16 16 0 0 1-.5.803l2.63 2.631 2.632-2.63a15 15 0 0 1-.5-.804 1 1 0 0 1 1.738-.99c.013.022 1.289 2.24 3.415 4.365 2.114 2.115 4.17 3.24 4.19 3.25a1 1 0 0 1-.95 1.76 13 13 0 0 1-.833-.503zM6.847 11.09a10.3 10.3 0 0 1 2.167-3.174l1.572-1.572-2.398-2.398c-.56.72-1.25 1.532-2.058 2.34a24 24 0 0 1-2.171 1.917zM8.809 16c1.877 0 3.659-.62 5.112-1.763L9.76 10.08A8.23 8.23 0 0 0 8 15.191v.81zM20.04 8.202a24 24 0 0 1-2.171-1.918 25 25 0 0 1-2.058-2.339l-4.678 4.678 4.243 4.243z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-crutches_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCrutches;
